import React, { useRef, useEffect, useState } from 'react'

import { Spinner } from 'spin.js'

import 'spin.js/spin.css'

const config = {
  lines: 6,
  length: 0,
  width: 10,
  radius: 10,
  corners: 1,
  rotate: 0,
  direction: 1,
  color: '#4CBAD7',
  opacity: 0.1,
  speed: 1.4,
  trail: 100,
  shadow: false,
  hwaccel: true,
  className: 'spinner',
  zIndex: 200,
  top: '50%',
  left: '50%'
}

const SingleLoader = ({ height }) => {
  const spinnerRef = useRef(null)
  const [spinner, setSpinner] = useState(null)

  useEffect(() => {
    if (spinnerRef && spinnerRef.current) {
      setSpinner(new Spinner(config).spin(spinnerRef.current))
    }

    return () => {
      if (spinner && spinner.stop) {
        spinner.stop()
      }
    }
  }, [])

  return (
    <div style={{ position: 'relative', height }} ref={spinnerRef} />
  )
}

export default SingleLoader
